
import Swipe from '@/components/Swipe.vue'
import { onActivated, shallowRef } from 'vue'
import Pic from 'common/Pic.vue'
import { readBanner, BannerSchema } from '@/modules/home/home.api'

export default {
  name: 'TheBanner',
  components: { Pic, Swipe },
  setup () {
    const banners = shallowRef<Array<BannerSchema>>([])
    onActivated(() => {
      readBanner().then(resp => banners.value = (resp) || [])
    })
    return {
      banners,
    }
  },
}
